module.exports = __webpack_public_path__ + "img/menu-dot.50cf9c8a.svg";